import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

//   const { worker } = await import('./mock');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
//   return worker.start();
}

enableMocking().then(() => {
  root.render(<App />);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
